import React, { Component } from "react";
import Total from "./total";
import Toggler from "./common/toggler";
import { getData } from "./../fakeSocialMediaAPI";
import Overview from "./overview";

class Dashboard extends Component {
  state = {
    socialMediaData: getData(),
    darkMode: true,
  };

  constructor(props) {
    super(props);
    console.log("Construction of Dashboard");
  }

  handleToggle = () => {
    let newMode = !this.state.darkMode;
    this.setState({ darkMode: newMode });
  };

  countTotalFollowers = (data) => {
    let result = data.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.totalFollowers;
    }, 0);
    //returns result with formatting: adding commas between thousands
    return result.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  render() {
    //console.log(this.state.socialMediaData);
    const { darkMode, socialMediaData } = this.state;
    return (
      <main
        className={
          darkMode ? "dashboard dashboard_dark" : "dashboard dashboard_light"
        }>
        <div className="dashboard-title">
          <div className="dashboard-title_title">
            {" "}
            <h1
              className={
                darkMode
                  ? "dashboard_dark_maintext"
                  : "dashboard_light_maintext"
              }>
              Social Media Dashboard
            </h1>
            <h3 className="dashboard_dark_secondarytext">
              {`Total Followers: ${this.countTotalFollowers(socialMediaData)}`}
            </h3>
          </div>
          <Toggler darkMode={darkMode} onToggle={this.handleToggle} />
        </div>
        <Total data={socialMediaData} darkMode={darkMode} />
        <Overview data={socialMediaData} darkMode={darkMode} />
      </main>
    );
  }
}

export default Dashboard;
